module.exports = __webpack_public_path__ + "media/src/images/signin-71d5931bfd93b7b25ddb6f555a4913de.png";